// CDHA Service for handling medical imaging data
const cdhaService = {
  /**
   * Fetch CDHA data by extern ID
   * @param {string} externId - The external ID for the CDHA record
   * @returns {Promise} - Promise with CDHA data
   */
  async getCdhaById(externId) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CRM_ENDPOINT_URL}/en/api/v1.0/KetQuaCdha/cdha?id=${externId}`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const json = await response.json();
      return json.data;
    } catch (error) {
      console.error("Error fetching CDHA data:", error);
      throw error;
    }
  },
  isNotImageUrl(url) {
      return !this.isImageUrl(url);
  },
  isImageUrl(url) {
      return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(url);
  }, 
  /**
   * Check if URL is a PDF
   * @param {string} url - URL to check
   * @returns {boolean} - True if PDF
   */
  isPdf(url) {
    return url.toLowerCase().endsWith('.pdf');
  },


  // /**
  //  * Check if URL is a PDF
  //  * @param {string} url - URL to check
  //  * @returns {boolean} - True if PDF
  //  */
  // isPdf(url) {
  //   return url.toLowerCase().endsWith('.pdf');
  // },

  /**
   * Format image gallery items from URLs
   * @param {Array} urls - Array of URL objects
   * @returns {Array} - Formatted gallery items
   */
  formatGalleryItems(urls) {
    if (!Array.isArray(urls)) return [];
    
    return urls.map((item) => {
      const url = item.original;
      
      // Check if PDF
      if (this.isNotImageUrl(url)) {
        return {
          original: item.thumbnail,
          thumbnail: item.thumbnail,
          description: item?.description || "",
          isPdf: true,
          pdfUrl: url
        };
      }
      
      // Regular image
      return {
        original: url,
        thumbnail: item.thumbnail || url,
        description: item?.description || "",
        isPdf: false
      };
    });
  },

  /**
   * Get panel title based on type
   * @param {number} typeCls - Classification type
   * @returns {string} - Panel title
   */
  getPanelTitle(typeCls) {
    return typeCls === 1 ? "Kết luận" : "Kết quả";
  }
};

export { cdhaService };
